const columns = [
  {
    name: 'Type',
    selector: (row) => row.name,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
